import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { notBlank } from "../../util/ext";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

const Login = () => {
  const auth = useSelector(state => state.auth);
  const navigate = useNavigate();
  useEffect(() => {
    // Catch if user is already logged in
    if (notBlank(auth.user)) {
      navigate("/home", { replace: true });
    }
  }, [auth, navigate]);
  return (
    <Box
      position="fixed"
      top={0}
      right={0}
      left={0}
      bottom={0}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Box>
  );
};

export default Login;
